import { render, staticRenderFns } from "./BirdsFurryComponent.vue?vue&type=template&id=5e850fa4&"
import script from "./BirdsFurryComponent.vue?vue&type=script&lang=ts&"
export * from "./BirdsFurryComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports